import React from 'react';
import { Badge, Form } from 'react-bootstrap';

function formatBrand(brand) {
  const label = String(brand || 'card').replace(/_/g, ' ');
  return label.charAt(0).toUpperCase() + label.slice(1);
}

/**
 * Saved card vs new card selection for subscribe / envelope pay.
 */
const PaymentMethodSelector = ({
  methods = [],
  defaultId,
  selection,
  onSelectionChange,
  selectedPaymentMethodId,
  onPaymentMethodIdChange,
  savePaymentMethod = true,
  onSavePaymentMethodChange,
  disabled = false,
  idPrefix = 'billing',
}) => {
  const hasSavedCards = methods.length > 0;
  const effectiveSelection = hasSavedCards ? selection : 'new';

  const pickDefault = () => {
    if (!hasSavedCards) return;
    onSelectionChange('saved');
    const defaultPm =
      methods.find((pm) => pm.id === defaultId || pm.is_default)
      ?? methods[0];
    if (defaultPm?.id) {
      onPaymentMethodIdChange(defaultPm.id);
    }
  };

  React.useEffect(() => {
    if (!hasSavedCards && selection !== 'new') {
      onSelectionChange('new');
    }
  }, [hasSavedCards, selection, onSelectionChange]);

  return (
    <div className="mb-3">
      <p className="small fw-semibold mb-2">Payment method</p>

      {hasSavedCards && (
        <>
          <Form.Check
            type="radio"
            id={`${idPrefix}-pay-saved`}
            name={`${idPrefix}-payment-selection`}
            label="Pay with saved card"
            checked={effectiveSelection === 'saved'}
            disabled={disabled}
            onChange={pickDefault}
            className="mb-2"
          />

          {effectiveSelection === 'saved' && (
            <div className="ms-4 mb-3">
              {methods.map((pm) => {
                const isDefault = pm.id === defaultId || pm.is_default;
                return (
                  <Form.Check
                    key={pm.id}
                    type="radio"
                    id={`${idPrefix}-pm-${pm.id}`}
                    name={`${idPrefix}-saved-pm`}
                    disabled={disabled}
                    checked={selectedPaymentMethodId === pm.id}
                    onChange={() => onPaymentMethodIdChange(pm.id)}
                    label={(
                      <>
                        {formatBrand(pm.brand)}
                        {' '}
                        ••••
                        {pm.last4}
                        {isDefault && (
                          <Badge bg="primary" className="ms-2">
                            Default
                          </Badge>
                        )}
                      </>
                    )}
                    className="mb-1"
                  />
                );
              })}
            </div>
          )}

          <Form.Check
            type="radio"
            id={`${idPrefix}-pay-new`}
            name={`${idPrefix}-payment-selection`}
            label="Use a different card"
            checked={effectiveSelection === 'new'}
            disabled={disabled}
            onChange={() => onSelectionChange('new')}
            className="mb-2"
          />
        </>
      )}

      {effectiveSelection === 'new' && (
        <Form.Check
          type="checkbox"
          id={`${idPrefix}-save-pm`}
          className={hasSavedCards ? 'ms-4' : ''}
          label="Save this card for future payments"
          checked={savePaymentMethod}
          disabled={disabled}
          onChange={(e) => onSavePaymentMethodChange?.(e.target.checked)}
        />
      )}
    </div>
  );
};

export default PaymentMethodSelector;
